module.exports = "pegasus_template/assets/circleline-twitter.gif";